// extracted by mini-css-extract-plugin
export var fullHeightState = "_1q-7";
export var headerCell = "_1q-1";
export var loadingStateCell = "_1q-4";
export var rowWrapper = "_1q-3";
export var standaloneTable = "_1q-8";
export var standaloneTableWithBodyFill = "_1q-9";
export var stateCell = "_1q-5";
export var table = "_1q-0";
export var tableBodyFiller = "_1q-6";
export var white = "_1q-2";